<template>
  <div class="left-nav">
    <Menu :active-name="curPage" :open-names="curMenu">
      <template v-for="menu in menuConfig">
        <MenuItem v-if="menu.url&&menu.show"
                  :key="menu.key"
                  :name="menu.name"
                  :to="menu.url">
          <Icon :key="menu.icon" :type="menu.icon"></Icon>{{menu.label}}
        </MenuItem>
        <Submenu v-if="menu.children&&menu.show" :key="menu.name" :name="menu.name">
          <template slot="title"><Icon :type="menu.icon"></Icon>{{menu.label}}</template>
          <MenuItem v-for="child in menu.children"
                    v-if="child.show"
                    :key="child.key"
                    :name="child.name"
                    :to="child.url"><Icon :key="child.icon" :type="child.icon"></Icon>{{child.label}}</MenuItem>
        </Submenu>
      </template>
    </Menu>
  </div>
</template>

<script>
import MenuConfig from '../../assets/js/menuConfig'
export default {
  data () {
    return {
      curPage: '',
      curMenu: [],
      menuConfig: []
    }
  },
  created () {
    const _self = this;
    _self.menuConfig = MenuConfig;
    // _self.initMenuActive();
    let permission = JSON.parse(_self.$store.state.permission);
    let mapPermission = {};
    let curPath = _self.$route.path;
    for (let menu of _self.menuConfig) {
      let curPermission = permission.filter(item => item.url === menu.name);
      if (curPermission.length > 0) {
        curPermission = curPermission[0];
        menu.show = true;
        mapPermission[menu.url] = true;
        menu.icon = curPermission.icon;
        // 初始化当前页面权限
        _self.$store.commit('pagePermissionInit', menu.list);
      } else {
        menu.show = false;
        continue;
      }
      if (menu.show && menu.url === curPath) {
        _self.curPage = menu.name;
      } else if (menu.children && menu.children.length > 0) {
        for (let child of menu.children) {
          let childPermission = curPermission.list.filter(item => item.url === child.name);
          child.show = childPermission.length > 0;
          mapPermission[child.url] = child.show;
          if (childPermission.length > 0) {
            child.icon = childPermission[0].icon;
          }

          if (child.show && child.url === curPath) {
            _self.curPage = child.name;
            _self.curMenu = [menu.name];
            // 初始化当前页面权限
            _self.$store.commit('pagePermissionInit', child.list);
          }
        }
      }
    }
    _self.$store.commit('permissionInit', mapPermission);
  },
  watch: {
    '$route' (to, from) {
      this.initMenuActive();
    }
  },
  methods: {
    initMenuActive () {
      const _self = this;
      let curPath = _self.$route.path;
      for (let menu of _self.menuConfig) {
        if (menu.show && menu.url === curPath) {
          _self.curPage = menu.name;
          // 初始化当前页面权限
          _self.$store.commit('pagePermissionInit', menu.list);
          break;
        } else if (menu.children && menu.children.length > 0) {
          for (let child of menu.children) {
            if (child.show && child.url === curPath) {
              _self.curPage = child.name;
              _self.curMenu = [menu.name];
              // 初始化当前页面权限
              _self.$store.commit('pagePermissionInit', child.list);
              break;
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
  .left-nav {
    .kh-menu-dark.kh-menu-vertical .kh-menu-item,
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu-title {
      color: #ffffff;
    }
    .kh-menu-dark.kh-menu-vertical .kh-menu-item:hover,
    .kh-menu-dark.kh-menu-vertical .kh-menu-item-active:not(.kh-menu-submenu),
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu-title-active:not(.kh-menu-submenu) {
      background: @base-color;
    }
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu .kh-menu-item:hover {

    }
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu .kh-menu-item:hover,
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu .kh-menu-item-active,
    .kh-menu-dark.kh-menu-vertical .kh-menu-submenu .kh-menu-item-active:hover {
      background: @base-color !important;
      color: #fff;
    }
    .kh-menu-submenu-title .kh-icon, .kh-menu-item .kh-icon {
      height: 14px;
      line-height: 12px;
      width: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/leftNav.vue